<div class="modals supplier" [class.modals-show]="isModalSupplierShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4>ЯК СТАТИ ПОСТАЧАЛЬНИКОМ MasloTochka:<br>ДЛЯ ТОГО ЩОБ СТАТИ НАШИМ ПОСТАЧАЛЬНИКОМ, НЕОБХІДНО:</h4>
  <h4 class="centered">ЗВ'ЯЗАТИСЯ З НАМИ</h4>
  <ul>
    <li>Для обговорення питань щодо співробітництва звертатися до відділу по роботі з постачальниками за телефоном:</li>
    <li>+38 (050) 654-40-90 Сергій</li>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
